export enum RouteEditMode {
  Default = 'Default',
  Move = 'Move',
}
